<template>
  <el-header class="layout-header hadbox-sec">
    <NavBarsIndex />
  </el-header>
</template>

<script>
import NavBarsIndex from '../navBars/index.vue'
export default {
  name: 'layoutHeader',
  components: { NavBarsIndex },
  data() {
    return {}
  }
}
</script>
